export default __webpack_public_path__ + "static/MIFA-50dd168fbb59ca6f34b0262b9f965e80.png";